import React, { useState } from "react";
import { Modal } from "antd";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { have_product_reference } from "../../../../../../helpers/OrdersFunctionsGlobal";

import { updateOrderRowGoods } from "../../../../../../redux/Actions/orderAction";
import { useDispatch } from "react-redux";
import { CheckBoxInput } from "../../../../Buttons";

const ServiceDisplay = ({ parent_id, order_row_id, order_id, order_rows }) => {
  const [showModal, setShowModal] = useState(false);

  order_rows = order_rows.filter((order_row) =>
    have_product_reference(order_row.product_reference)
  );
  return (
    <>
      <AiOutlineCheckCircle
        onClick={() => {
          setShowModal(true);
        }}
        className={`text-${parent_id ? "success" : "danger"} mr-1`}
      />
      {showModal && (
        <ModalServiceDisplay
          parent_id={parent_id}
          order_row_id={order_row_id}
          order_rows={order_rows}
          order_id={order_id}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ServiceDisplay;

const ModalServiceDisplay = ({
  parent_id,
  order_row_id,
  order_rows,
  order_id,
  onClose,
}) => {
  const dispatch = useDispatch();
  const [parentId, setParentId] = useState(parent_id || null);
  const [loading, setLoading] = useState(false);
  order_rows = order_rows.filter((order_row) =>
    have_product_reference(order_row.product_reference)
  );

  return (
    <Modal
      open={true}
      title={"Additionally assign service to product"}
      onOk={async () => {
        try {
          if (loading) return;
          setLoading(true);
          await dispatch(
            updateOrderRowGoods(
              {
                order_row: {
                  parent_id: parentId,
                },
              },
              order_id,
              order_row_id
            )
          );
          onClose();
        } finally {
          setLoading(false);
        }
      }}
      onCancel={() => onClose()}
    >
      {order_rows?.map(({ product_reference, product_name, id }, idx) => (
        <div
          className="my-1"
          key={id}
          style={{
            borderBottom:
              order_rows.length !== idx + 1 ? "1px solid #DEE2E6" : "none",
          }}
        >
          <CheckBoxInput
            checked={parentId == id}
            text={`(${product_reference}) ${product_name}`}
            onChange={() => {
              setParentId((prev) => (prev == id ? null : id));
            }}
          />
        </div>
      ))}
    </Modal>
  );
};
